<template>
	<div ref="invitaion_item" class="full-width inv-record-tr-box" style="margin: 0;" v-loading="loading">
		<el-row>
			<el-col :span="textSpan">
				<span tkey="公司名稱">{{i18n.tkey("lang_company_name")}} : {{invataionObj.companyname}}</span>
			</el-col>

		<el-col :span="textSpan">
			<span tkey="電子郵箱">{{i18n.tkey("lang_email")}} : {{invataionObj.login}}</span>
		</el-col>
		<el-col :span="textSpan">
			<span tkey="姓名">{{i18n.tkey("lang_name")}} : {{invataionObj.name}}</span>
		</el-col>
		
		<el-col :span="textSpan">
			<span tkey="激活時間">{{i18n.tkey("lang_activate_time")}} : {{invataionObj.addinfo6}}</span>
		</el-col>


		<el-col :span="textSpan">
			<span style="webkit-user-select:text;" tkey="密碼">{{i18n.tkey("lang_password")}} : {{invataionObj.password}}</span>
		</el-col>

		<el-col :span="textSpan">
			<span tkey="邀請碼">{{i18n.tkey("lang_inv_code")}} : {{invataionObj.addinfo3}}</span>
		</el-col>

		<el-col :span="textSpan">
			<span tkey="邀請者郵箱">{{i18n.tkey("lang_inv_user_login")}} : {{invataionObj.invLogin}}</span>
		</el-col>
		
		<el-col :span="textSpan">
			<span tkey="邀請者姓名">{{i18n.tkey("lang_inv_user_name")}} : {{invataionObj.invName}}</span>
		</el-col>

			<el-col :span="textSpan" v-if="null != invataionObj.memberworkid">
				<br>
				<el-button @click="sendRecord1Request" tkey="名片收錄">{{i18n.tkey("lang_memberwork_collection")}}</el-button>
				<br>
				<br>
			</el-col>
		</el-row>
	</div>
</template>

<script setup>
	import {getCurrentInstance, inject, onMounted, ref, toRef} from "vue";
	import record1Api from "@/request/record1Api";
	import {useUserinfo} from "@/stores/userinfo";
	import myUtil from "@/util/util";

	const props = defineProps(["invataionObj", "objIndex"])
	const { proxy } = getCurrentInstance()

	const i18n = inject("i18n")

	const textSpan = ref(8)

	const componentWidth = ref(375)

	const userinfoRef = toRef(useUserinfo())
	const loading = ref(false)

	function sendRecord1Request(){
		loading.value = true

		const request = record1Api.sendRecord1
		const params = request.getParams()

		params.addinfo2 = props.invataionObj.memberworkid
		params.login = userinfoRef.value.login
		params.addinfo3 = 1
		params.companycode = userinfoRef.value.companycode

		request.send(params, (res) => {
			loading.value = false
			if (res.code == 200){
				myUtil.alertSuccess(i18n.tkey("lang_success_include"))
			}else{
				myUtil.alertWarning(res.msg)
			}
		})

	}

	onMounted(() => {
		componentWidth.value = proxy.$refs.invitaion_item.offsetWidth

		if (componentWidth.value < 768){
			textSpan.value = 24
		}
	})
	
</script>

<style scoped>
	.inv-record-tr-box{border-bottom: 1px #d9d9d9 solid;}
</style>